import { NoToneMapping, SRGBColorSpace, WebGLRenderer } from "three";

export class UnsupportedError extends Error {}

/** Renderizador WebGL2 (obrigatório, doc 07 A12) com pixel ratio limitado para desempenho. */
export function createRenderer(canvas: HTMLCanvasElement): WebGLRenderer {
  if (!canvas.getContext("webgl2")) {
    throw new UnsupportedError("Seu navegador não oferece WebGL2, necessário para jogar o Eldrun.");
  }
  const renderer = new WebGLRenderer({ canvas, antialias: true, powerPreference: "high-performance" });
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  renderer.outputColorSpace = SRGBColorSpace;
  // A paleta do doc 05 foi pensada sem tone mapping.
  renderer.toneMapping = NoToneMapping;
  // F52: o `info` zera uma vez por quadro (`FrameStats.begin`), não a cada `render()`: senão o
  // triângulo do pós, os ícones ou uma sonda apagariam a contagem da cena.
  renderer.info.autoReset = false;
  return renderer;
}
